import type { IIssueRepository, IssueCreateInput } from '../repositories/IIssueRepository.js';
import type { IssueEntity } from '../entities/IssueEntity.js';

interface Deps { issueRepository: IIssueRepository; }

export function createCreateIssueUseCase({ issueRepository }: Deps) {
  return async function createIssue(input: IssueCreateInput): Promise<IssueEntity> {
    return issueRepository.create(input);
  };
}
